<template>
    <section class="calendar">
        <div class="header">
            <a v-if="isShowPre" href="javascript:;" @click="prevHandler">
              <i class="iconfont iconcalendar-zuo"></i>
            </a>
            <span>{{currentFormat}}</span>
            <a v-if="isShowNext" href="javascript:;" @click="nextHandler">
              <i class="iconfont iconcalendar-you"></i>
            </a>
        </div>
        <ul v-if="show"  class="weekday">
          <li v-for="(item,index) in weekdays" :key="`d_${index}`">{{item}}</li>
        </ul>
        <ul v-if="show" class="days">
            <li v-for="(item,index) in days" :key="index" :class="{'disable':item.disable}">
                <div   @click="chooseDateHandler(item)" :class="{'kuang':item.active,'today': item.today}"> {{formatDate(item)}}</div>
                <div class="append">
                    <slot name="append" :date="item.date"></slot>
                </div>
            </li>
        </ul>
    </section>
</template>

<script>
export default {
data(){
    return {
        show:true,
        isShowNext:true,
        isShowPre:true,
        current:new Date(),
        weekdays:['日','一','二','三','四','五','六'],
        items:[]
    };
},

computed:{
    currentFormat(){
        return `${this.current.getFullYear()}年${this.current.getMonth()+1}月`;
    },
    year(){
        return this.current.getFullYear();
    },
    month(){
        return this.current.getMonth();
    },
    date(){
        return this.current.getDate();
    },
    days(){
        this.items=[];
        //第一天到下月第一天时间除去毫秒得到总天数
        var next=new Date(this.year,this.month+1,1);
        var first=new Date(this.year,this.month,1);
        var days=(next.getTime()-first.getTime())/(24*60*60*1000);
        var preAdd=first.getDay();
        var total=Math.ceil((preAdd+days)/7)*7;
        for(let i=0;i<total;i++){
            var v=i-preAdd;
            var currentDay=new Date(new Date().setHours(0,0,0,0));
            if(v>=0&& v<days){
                var currentMonthDays=new Date(this.year,this.month,v+1);
                if(currentMonthDays<currentDay){
                    this.items.push({disable:false,active:false,date:currentMonthDays,dateId:this.dateToStr(currentMonthDays),today: false});
                }else if(currentMonthDays>currentDay){
                   this.items.push({disable:false,active:false,date:currentMonthDays,dateId:this.dateToStr(currentMonthDays),today: false});
                }else{
                    this.items.push({disable:false,active:false,date:currentMonthDays,dateId:this.dateToStr(currentMonthDays),today: true});
                }
            }else{
                var notCurrentMonthDays=new Date(first.getTime()+(i-preAdd)*24*60*60*1000);
                if(notCurrentMonthDays<currentDay){
                    this.items.push({disable:true,active:false,date:notCurrentMonthDays,dateId:this.dateToStr(notCurrentMonthDays),today: false});
                }else{
                   this.items.push({disable:true,active:false,date:notCurrentMonthDays,dateId:this.dateToStr(notCurrentMonthDays),today: false});
                }
            }
        }
        return this.items;
    }
},
mounted(){
},
methods:{
    prevHandler(){
        //上个月1号
        this.current=new Date(this.year,this.month-1,1);
        this._notify();
        this.show=true;
        this.isShowPre=this.isPreMonth();
        this.isShowNext=this.isNextMonth();
    },
    nextHandler(){
        //下个月1号
        this.current=new Date(this.year,this.month+1,1);
        this._notify();
        this.show=true;
        this.isShowPre=this.isPreMonth();
        this.isShowNext=this.isNextMonth();
    },
    formatDate(value){
        return `${value.date.getDate()}`;
    },
    _notify(){
        if(this.current.getDate()==new Date().getDate()){
            this.$emit('change',this.current,this.items[0].date,this.items[this.items.length-1].date);
        }else{
            this.$emit('change',this.current,this.startDay(this.current),this.endDay(this.current));
        }
    },
    dateToStr(date){
        var year = date.getFullYear()
        var month = (date.getMonth() + 1);
        var day = date.getDate();
        if (month < 10) {
            month = "0" + month;
        }
        if (day < 10) {
            day = "0" + day;
        }
        return year+month+day;
    },
    startDay(date1){
        var date=new Date(date1);
        return new Date(date.setTime(date.getTime()-date.getDay()*24*60*60*1000));

    },
    endDay(date1){
        var date=new Date(date1);
        let _start= new Date(date.setTime(date.getTime()-date.getDay()*24*60*60*1000));
        var next=new Date(this.year,this.month+1,1);
        var first=new Date(this.year,this.month,1);
        let days=(next.getTime()-first.getTime())/(24*60*60*1000);
        let total=Math.ceil((first.getDay()+days)/7)*7;
        return new Date(date.setTime(_start.getTime()+(total-1)*24*60*60*1000));
    },
    chooseDateHandler(item){
        // 先使得框显示
       this.items.map(it=>{
           if(it.dateId==item.dateId){
              it.active=true;
           }else{
             it.active=false;
           }
       })
      //  通知父组件修改列表的显示
      this.$emit('chooseDate',item);
    },
    // 会议只需要展示当前月和它前后6个月的会议列表
    isPreMonth(){
        var currentmonth=this.current.getMonth();
        var nowMonth=new Date().getMonth();
        if(this.current<new Date()){
            if(nowMonth>=currentmonth){
                if(nowMonth-currentmonth>5) return false;
            }else{
                if(nowMonth+12-currentmonth>5) return false;
            }
            return true
        }
        return true;
    },
    isNextMonth(){
        var currentmonth=this.current.getMonth();
        var nowMonth=new Date().getMonth();
        if(this.current>new Date()){
            if(currentmonth>=nowMonth){
                if(currentmonth-nowMonth>5) return false;
            }else{
                if(currentmonth+12-nowMonth>5) return false;
            }
            return true
        }
        return true;
    }
  }
}
</script>

<style lang="less" scoped>
section{
    *:not(.iconfont) {
        font-family: 'source' !important;
    }
    .header{
        font-size: 1.4em;
        font-weight: 600;
        text-align:center;
        line-height:50px;
        border-bottom: 1px solid #fafafa;
        > a{
            color: #222;
            text-decoration: none;
            margin:.5em;
        }
        .iconfont {
            color: black;
            font-weight: 900;
            font-size: 1.4em !important;
        }
    }

    ul{
        list-style: none;
        margin: 0;
        padding:0;
        &::before,&::after{
            content:"";
            display: block;
            clear:both;
        }
        &.weekday{
            margin-left: 2%;
            margin: 10px 2% 15px;
            > li{
                float:left;
                width: 14%;
                box-sizing: border-box;
                text-align: center;
                line-height: 0px;
                line-height: 30px;
                font-size: 1.2em;
            }
        }
        &.days{
            margin:0 2%;
            &:before,&:after{
                content:"";
                display: block;
                clear:both;
                visibility: hidden;
            }
            > li{
                float:left;
                width: 14%;
                box-sizing: border-box;
                text-align: center;
                line-height: 0px;
                height: 45px;
                font-size: 1.2em;
                &.disable{
                    >div{
                        color:#CCC;
                    }
                }
                > div{
                    height:24px;
                    line-height: 24px;
                    position: relative;
                    &.append{
                        height: 24px;
                        box-sizing: border-box;
                        overflow: hidden;
                        line-height: normal;
                        display: flex;
                        justify-content: center;
                        span{
                            border: 1px solid transparent;
                            max-width: 100%;
                            box-sizing: border-box;
                            margin: 0 2px;
                            padding:2px 2px;
                            font-size: 8px;
                            line-height: 10px;
                            border-radius: 3px;
                            text-overflow: ellipsis;
                            overflow: hidden;
                            word-break: keep-all;
                        }
                    }
                    &.kuang::before{
                        content: "";
                        border:1px solid red;
                        position: absolute;
                        height: 24px;
                        width: 24px;
                        left: 50%;
                        top: 50%;
                        transform: TRANSLATE3D(-50%,-50%,0);
                    }
                    &.today{
                      color:red;
                    }
                }
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/myComponents/calendar.vue